import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _isArray from "lodash/isArray";
import _isPlainObject from "lodash/isPlainObject";
import _has from "lodash/has";
import _get from "lodash/get";
import _set from "lodash/set";
import _each from "lodash/each";
import { createStore } from 'redux';
var SET = 'SET';
var REMOVE = 'REMOVE';

function contextReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var type = action.type,
      path = action.path,
      payload = action.payload;

  switch (type) {
    case SET:
      {
        var ctx = path.length ? "".concat(path.join('.'), ".") : '';

        _each(payload, function (value, key) {
          return _set(state, "".concat(ctx).concat(key), value);
        });

        return state;
      }

    case REMOVE:
      {
        var data = path.length ? _get(state, path.join('.')) : state;

        _each(payload, function (key) {
          if (_has(data, key)) delete data[key];
        });

        return state;
      }

    default:
      return state;
  }
} // internal redux-based implementation of an observable object store


export default function createReduxContextStore(_ref) {
  var preloadData = _ref.preloadData;
  var reduxStore = createStore(contextReducer, preloadData);
  return {
    subscribe: reduxStore.subscribe,
    get: function get(key, path) {
      var state = reduxStore.getState();
      var data = path.length ? _get(state, path.join('.'), {}) : state;
      if (key) return _get(data, key);
      return data;
    },
    set: function set(key, value) {
      var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      if (!key) return reduxStore.dispatch({
        type: SET,
        payload: value,
        path: path
      });
      if (_isPlainObject(key)) return reduxStore.dispatch({
        type: SET,
        payload: key,
        path: path
      });
      return reduxStore.dispatch({
        type: SET,
        payload: _defineProperty({}, key, value),
        path: path
      });
    },
    remove: function remove(keys) {
      var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var payload = _isArray(keys) ? keys : [keys];
      return reduxStore.dispatch({
        type: REMOVE,
        payload: payload,
        path: path
      });
    }
  };
}